<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="body"><span class="pagebreak" id="page1" title="1"></span></p>
<p class="body"><span class="pagebreak" id="page2" title="2"></span></p>
<p class="body"><span class="pagebreak" id="page3" title="3"></span></p>
<p class="tp1"><br/>
    STILL LIFE</p>
<p class="tp2">A MEMOIR <i>of</i> LIVING FULLY</p>
<p class="tp2"><i>with</i> DEPRESSION</p>
<p class="dingbat" id="_idContainer000"><img alt="" src="Images/4324_graphic_TP.png"/></p>
<p class="tp3">Gillian Marchenko</p>
<p class="first"><br/></p>
<p class="firstcenter"><a href="http://www.ivpress.com/books" target="_blank"><img alt="IVP Books Imprint" src="Images/IVPBooks.png"/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?01945dc7